<template>
    <div class="page">
        <box>
            <el-form label-position="right" label-width="80px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                     <el-form-item label="库位编号" class="EL-Form-Item">
                    <el-select v-model="mainSearch.query.lcCode" placeholder="请选择" :clearable="true" filterable remote :remote-method="remoteMethodLcCode">
                        <el-option v-for="(item, index) in lcCodeList" :key="index" :label="item.lcCode" :value="item.lcCode">
                        </el-option>
                    </el-select>
                </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料编号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.query.matCode" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="订单编号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.query.orderCode" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="批次号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.query.batchNo" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getTableData">查询</el-button>
                        <el-button class="btn-t-delete" @click="resetClick('mainSearch')">重置</el-button>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料状态" class="EL-Form-Item">
                        <el-select multiple collapse-tags v-model="mainSearch.query.sckStatusList" clearable="clearable">
                            <el-option key="1" value="NORMAL" label="正常"></el-option>
                            <el-option key="2" value="FREEZE" label="拣配中"></el-option>
                            <!-- <el-option key="3" value="OVERTIME" label="过期"></el-option>
                            <el-option key="4" value="DELETE" label="作废"></el-option> -->
                            <el-option key="5" value="AGFREEZE" label="冻结"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="箱号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.query.boxBarcode" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="开始日期" class="EL-Form-Item">
                        <el-date-picker v-model="mainSearch.query.beginTime" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="startPickerOptions"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="结束日期" class="EL-Form-Item">
                        <el-date-picker v-model="mainSearch.query.endTime" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="finishPickerOptions"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                  <el-form-item label="仓库库存" class="EL-Form-Item">
                    <el-select collapse-tags v-model="mainSearch.query.whType" placeholder="请选择" clearable="clearable">
                      <el-option  key="" label="全部" value=""></el-option>
                      <el-option  key="1" label="是" value="1"></el-option>
                      <el-option  key="2" label="否" value="2"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
            </el-form>
        </box>
        <box fill>
            <plabel text="物料状态转换">
                <el-button class="btn-t-edit" v-authority="'BACK_MENU2_M8_B1'" @click="changeStatus('NORMAL', 'AGFREEZE')">物料冻结</el-button>
                <el-button class="btn-t-edit" v-authority="'BACK_MENU2_M8_B2'" @click="changeStatus('AGFREEZE', 'NORMAL')">物料解冻</el-button>
                <!-- <el-button class="btn-t-edit" v-authority="'BACK_MENU2_M8_B3'" @click="openAgfreezePickingListShow()">拣配列表</el-button> -->
                <el-button v-authority="'BACK_MENU2_M8_B4'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
            </plabel>
            <h-table :headerCellStyle="mainData.headerCellStyle" style="flex: 1" @pageChange="getTableData" :data="mainData.data" pagination :nowPage.sync="mainData.nowPage" :pageSize.sync="mainData.pageSize" :total.sync="mainData.total" ref="hTable" @selectionChange="selectAll">
                <el-table-column type="selection" align="center"></el-table-column>
                <el-table-column label="通道编号" align="center" prop="whCode">
                </el-table-column>
                <el-table-column label="物料编号" align="center" prop="matCode">
                </el-table-column>
                <el-table-column label="物料描述" align="center" prop="matName">
                </el-table-column>
                <el-table-column label="订单编号" align="center" prop="orderCode">
                </el-table-column>
                <el-table-column label="物料数量" align="center" prop="matQuan">
                </el-table-column>
                <el-table-column label="库位编号" align="center" prop="lcCode">
                </el-table-column>
                <el-table-column label="箱号" align="center" prop="boxBarcode">
                </el-table-column>
                <el-table-column label="批次号" align="center" prop="batchNo">
                </el-table-column>
                <el-table-column label="物料状态" align="center" width="120px">
                    <template slot-scope="scope">
                        <span v-if="scope.row.wiStatus == 'NORMAL'">正常</span>
                        <span v-if="scope.row.wiStatus == 'FREEZE'">拣配中</span>
                        <!-- <span v-if="scope.row.wiStatus == 'OVERTIME'">过期</span>
                        <span v-if="scope.row.wiStatus == 'DELETE'">作废</span> -->
                        <span v-if="scope.row.wiStatus == 'AGFREEZE'">冻结</span>
                    </template>
                </el-table-column>
                <el-table-column label="规值" align="center" prop="matSpecs">
                </el-table-column>
                <el-table-column label="入库时间" align="center" prop="matCreateTime">
                </el-table-column>
                <el-table-column label="创建时间" align="center" prop="createTime">
                </el-table-column>
            </h-table>
        </box>

        <!-- 拣配列表 -->
        <el-dialog title="拣配列表" :visible.sync="agFreezePickingListShow" class="fromDialog" :style="$popups.popups(0.8,0.9)" :close-on-click-modal="false" :show-close="false">
            <div>
                <div style="font-size: 16px;float:right;margin: 5px 0px">
                    <el-button class="btn-t-edit" @click="taskDistribution()">
                        任务下发
                    </el-button>
                </div>
                <h-table :headerCellStyle="agFreezePickList.headerCellStyle" :style="$popups.harvestRecordStyle(0.7)" :data="agFreezePickList.data" pagination :nowPage.sync="agFreezePickList.nowPage" :pageSize.sync="agFreezePickList.pageSize" :total.sync="agFreezePickList.total" @pageChange="getAgfreezePickingList()" @selectionChange="selectList">
                    <el-table-column type="selection" align="center"></el-table-column>
                    <el-table-column label="通道编号" align="center" prop="whCode">
                    </el-table-column>
                    <el-table-column label="物料编号" align="center" prop="matCode">
                    </el-table-column>
                    <el-table-column label="物料描述" align="center" prop="matName">
                    </el-table-column>
                    <el-table-column label="订单编号" align="center" prop="orderCode">
                    </el-table-column>
                    <el-table-column label="物料数量" align="center" prop="matQuan">
                    </el-table-column>
                    <el-table-column label="库位编号" align="center" prop="lcCode">
                    </el-table-column>
                    <el-table-column label="箱号" align="center" prop="boxBarcode">
                    </el-table-column>
                    <el-table-column label="批次号" align="center" prop="batchNo">
                    </el-table-column>
                    <el-table-column label="库存状态" align="center" prop="wifStatus">
                        <template slot-scope="scope">
                            <span v-if="scope.row.wifStatus == '10'">冻结</span>
                            <span v-if="scope.row.wifStatus == '20'">解冻</span>
                            <span v-if="scope.row.wifStatus == '30'">待拣配</span>
                            <span v-if="scope.row.wifStatus == '40'">已拣配</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="规值" align="center" prop="matSpecs">
                    </el-table-column>
                    <el-table-column label="入库时间" align="center" prop="matCreateTime">
                    </el-table-column>
                    <el-table-column label="创建时间" align="center" prop="createTime">
                    </el-table-column>
                </h-table>
            </div>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button @click="closeAgfreezePickingListShow" type="info" class="btn-t-info">关 闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data(){
        return {
            mainSearch:{
                query:{
                    fcCode: localStorage.getItem("fcCode") || "", // 工厂编号
                    lcCode: "", //	库位编号
                    matCode: "", //	物料编号
                    orderCode: "", //	物料描述
                    batchNo: "", //	批次号
                    wiStatus: "", // 库存状态
                    boxBarcode: "", //	箱号
                    sckStatusList: "",
                    beginTime: "",
                    endTime: "",
                    whType:"",
                },
            },
            mainData:{
                data: [],
                nowPage: 1,
                pageSize: 20,
                total: 0,
                headerCellStyle: () => {
                    return "background-color: #1f6cec";
                },   
            },
            checkList:[],
            downloadLoading: false, //下载中
            // 输入框延时加载
            isSetTimeout: null,
            returnData:"",

            //拣配列表窗口
            agFreezePickingListShow: false,
            //拣配列表数据
            agFreezePickList:{
                data: [],
                nowPage: 1,
                pageSize: 20,
                total: 0,
                headerCellStyle: () => {
                    return "background-color: #1f6cec";
                },    
            },
            //人工冻结状态
            agFreezeStatus:"10,30",
            //任务下发库存对象集合
            checkListAll:[],
            //任务下发动态加载
            taskDistributionLoading:false,
            //操作人
            person: localStorage.getItem("user"),
            //操作人工号
            personNumber: localStorage.getItem("empNumber"),
            //冻结下发拣配单
            pmType:"agFreeze",
            // 库区
            lcCodeList: [],
        }
    },
    computed: {
        startPickerOptions() {
            let _this = this;
            return {
                disabledDate(time) {
                    if (_this.mainSearch.query.beginTime) {
                        return time.getTime() > new Date(_this.mainSearch.querybeginTime);
                    }
                },
            };
        },
        finishPickerOptions() {
            let _this = this;
            return {
                disabledDate(time) {
                    if (_this.mainSearch.query.endTime) {
                        return time.getTime() < new Date(_this.mainSearch.query.endTime);
                    }
                },
            };
        },
    },
    watch:{
        "mainSearch.query":{
           handler() {
            clearTimeout(this.isSetTimeout);
                this.isSetTimeout = setTimeout(() => {
                    this.getTableData();
                }, 1000);
            },
            deep: true,
        }
    },
    methods:{
        selectAll(val) {
            this.checkList = val;
        },
        selectList(val){
            this.checkListAll = val;
        },
        /* 获取所有的库位 */
        getSysLocationAll(lcCode) {
        this.$http
            .request({
            url: "/api/location/getLaCodeAllByType",
            method: "GET",
            params: {
                lcType: "AD",
                fcCode: localStorage.getItem("fcCode") || "",
                lcCode: lcCode || "",
            },
            })
            .then((resp) => {
            if (resp.status == 100) {
                if (resp.data && resp.data.list) {
                this.lcCodeList = resp.data.list;
                }else{
                this.lcCodeList = [];
                }
            }
            })
            .catch((error) => {
            this.$message({
                message: "操作失败",
                type: "warning",
            });
            });
        },
        /* 远程搜索库位号 */
        remoteMethodLcCode(query) {
        if (query || query == 0) {
            this.lcCodeLoading = true;
            this.mainSearch.query.lcCode = query;
            this.getSysLocationAll(this.mainSearch.query.lcCode);
            setTimeout(() => {
            this.lcCodeLoading = false;
            if (this.lcCodeList != undefined) {
                this.lcCodeList = this.lcCodeList.filter(
                (item) => {
                    return (
                    item.lcCode.toLowerCase().indexOf(query.toLowerCase()) > -1
                    );
                }
                );
            }
            }, 200);
        } else {
            this.lcCodeList = [];
        }
        },
        /**
         * 任务下发 生成叫料单以及拣配单数据
         */
        taskDistribution(){
            if (this.checkListAll.length == 0) {
                this.$message({
                    type: "warning",
                    message: "请选择一条冻结的物料进行任务下发！",
                });
                return;
            }
            var flag = false;
            this.checkListAll.forEach((item)=>{
                item.matRealQuan = item.matQuan
                if(item.wifStatus != '10'){
                    flag = true;
                }
            })
            if (flag) {
                this.$message({
                    type: "warning",
                    message: "只能对冻结状态的物料进行任务下发！",
                });
                return;
            }
            this.$confirm("是否确认下发任务？", "提示", {
                confirmButtonText: "确认",
                cancelButtonText: "取消",
                type: "warning",
            })
            .then(() => {
                this.taskDistributionLoading = true;
                this.$http
                    .request({
                        url:"/api/stockFreezeMat/insertTaskDistribution/",
                        method: "POST",
                        showLoading: true,
                        params:{
                            person: this.person, 
                            personNumber: this.personNumber,
                        },
                        data: this.checkListAll,
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.$message({
                                message: "下发任务成功",
                                type: "success",
                            });
                            this.logRemarks = "stockProduceMat：下发任务成功";
                            this.getAgfreezePickingList();
                        } else {
                            this.$message({
                                message: resp.message,
                                type: "error",
                            });
                            this.logRemarks = "stockProduceMat：下发任务失败";
                        }
                        this.taskDistributionLoading = false;
                        this.logContent = JSON.stringify(this.checkListAll);
                        this.systemLog();
                    })
                    .catch((error) => {
                        this.taskDistributionLoading = false;
                        this.$message({
                            message: "操作失败",
                            type: "error",
                        });
                    });
            })
            .catch(() => {
                this.taskDistributionLoading = false;
                this.$message({
                    type: "info",
                    message: "已取消",
                });
            });
        },
        /**
         * 打开拣配列表窗口
         */
        openAgfreezePickingListShow(){
            this.getAgfreezePickingList();
            this.agFreezePickingListShow = true;
        },
        /**
         * 关闭拣配列表窗口
         */
        closeAgfreezePickingListShow(){
            this.agFreezePickingListShow = false;
        },
        /**
         * 获取所有人工冻结的库存数据
         */
        getAgfreezePickingList(){
            this.$http
                .request({
                    url: "/api/StockMatChangeRecord/getAgfreezePickingList",
                    method: "GET",
                    params: {
                        pageNum: this.agFreezePickList.nowPage, //	页号
                        pageSize: this.agFreezePickList.pageSize, //	页大小
                        fcCode: this.mainSearch.query.fcCode || null, //	工厂编号
                        wifStatus: this.agFreezeStatus || null, //	库存状态
                    },
                })
                .then((res) => {
                    if (res.status == 100) {
                        this.agFreezePickList.data = res.data.list || [];
                        this.agFreezePickList.total = res.data.total || 0;
                    } else {
                        this.$message.error("错误");
                    }
                });
        },
        /* 所有重置按钮的事件 */
        resetClick(type){
            if (type == "mainSearch") {
                this.mainSearch.query = {
                    fcCode: localStorage.getItem("fcCode") || "", // 工厂编号
                    lcCode: "", //	库位编号
                    matCode: "", //	物料编号
                    orderCode: "", //	物料描述
                    batchNo: "", //	批次号
                    wiStatus: "", // 库存状态
                    boxBarcode: "", //	箱号
                    sckStatusList: "",
                    beginTime: "",
                    endTime: "",
                    whType:"",
                };
                this.mainData.nowPage = 1;
            }
        },
        changeStatus(oldStatus, status) {
            this.flag = true;
            this.statusFlag = true;
            if (this.checkList.length == 0) {
                this.$message({
                    message: "请勾选物料！",
                    type: "warning",
                });
                return;
            }

            //拼接要变更物料状态的库存对象
            var statusOne = this.checkList[0].wiStatus;
            var statusFlag = false;
            this.checkList.forEach((item) => {
                this.returnData = this.returnData + item.wiId + ",";
                //判断物料状态是否一样
                if (statusOne != item.wiStatus) {
                    //清除复选项拼接的id
                    this.returnData = "";
                    this.statusFlag = false;
                    statusFlag = true;
                }
            });
            if(statusFlag){
                this.$message({
                    message: "请选择状态一致的物料！",
                    type: "warning",
                });
                return;
            }

            //物料状态一致的情况
            if (this.statusFlag) {
                //判断操作的内容
                if (oldStatus == "NORMAL" && status == "AGFREEZE") {
                    this.change = "冻结";
                    //判断是否是针对正常状态的物料进行冻结操作
                    if (!(this.checkList[0].wiStatus == "NORMAL")) {
                        this.flag = false;
                        //清除复选项拼接的id
                        this.returnData = "";
                        this.$message({
                            message: "请对正常状态的物料进行人工冻结！",
                            type: "warning",
                        });
                        return;
                    }
                } else if (oldStatus == "AGFREEZE" && status == "NORMAL") {
                    this.change = "解冻";
                    //判断是否是针对冻结状态的物料进行解冻操作
                    if (!(this.checkList[0].wiStatus == "AGFREEZE")) {
                        this.flag = false;
                        //清除复选项拼接的id
                        this.returnData = "";
                        this.$message({
                            message: "请对人工冻结状态的物料进行解冻！",
                            type: "warning",
                        });
                        return;
                    }
                } else if (oldStatus == "NORMAL" && status == "DELETE") {
                    this.change = "转废";
                    //判断是否是针对正常状态的物料进行转废操作
                    if (this.checkList[0].wiStatus != "NORMAL" && this.checkList[0].wiStatus != "AGFREEZE") {
                        this.flag = false;
                        //清除复选项拼接的id
                        this.returnData = "";
                        this.$message({
                            message: "请对正常状态或者人工冻结状态的物料进行转废！",
                            type: "warning",
                        });
                        return;
                    }
                } else if (oldStatus == "DELETE" && status == "NORMAL") {
                    this.change = "取消转废";
                    //判断是否是针对转废状态的物料进行取消转废操作
                    if (!(this.checkList[0].wiStatus == "DELETE")) {
                        this.flag = false;
                        //清除复选项拼接的id
                        this.returnData = "";
                        this.$message({
                            message: "请对转废状态的物料进行取消转废！",
                            type: "warning",
                        });
                        return;
                    }
                }
                //物料转换是否正常操作
                if (this.flag) {
                    this.returnData = this.returnData.substr(0,this.returnData.length - 1);
                    this.$confirm("是否确认对物料" + this.change + "?", "提示", {
                            confirmButtonText: "确认",
                            cancelButtonText: "取消",
                            type: "warning",
                        })
                        .then(() => {
                            this.$http
                                .request({
                                    url: "/api/SplitMergeMatChange/updateMatStatus",
                                    method: "PUT",
                                    showLoading: true,
                                    params: {
                                        wiIds: this.returnData, //	变更状态的库存id
                                        status: status, // 变更状态
                                        person: this.person, //变更操作人
                                        personNumber: this.personNumber, //变更操作人工号
                                    },
                                })
                                .then((res) => {
                                    this.logContent =
                                        "wiIds：" + this.returnData + "\t" + "status：" + status;
                                    if (res.status == 100) {
                                        this.mainData.data = res.data.list;
                                        this.mainData.total = res.data.total;
                                        this.returnData = "";
                                        this.$message({
                                            message: "物料状态" + this.change + "成功",
                                            type: "success",
                                        });
                                        this.logRemarks =
                                            "splitMergeMatChange：物料状态转换" +
                                            this.change +
                                            "成功";
                                        this.getTableData();
                                    } else {
                                        this.returnData = "";
                                        this.$message({
                                            message: res.message,
                                            type: "error",
                                        });
                                        this.logRemarks =
                                            "splitMergeMatChange：物料状态转换" +
                                            this.change +
                                            "失败";
                                    }
                                    this.systemLog();
                                });
                        })
                        .catch(() => {
                            this.returnData = "";
                            this.$message({
                                type: "info",
                                message: "已取消",
                            });
                        });
                }
            }
        },
        /* 获取首页数据*/
        getTableData() {
            if (this.mainSearch.query.sckStatusList) {
                var sckStatusList = this.mainSearch.query.sckStatusList.join(",");
            }
            this.$http
                .request({
                    url: "/api/inventory/getInventoryData",
                    method: "GET",
                    params: {
                        pageNum: this.mainData.nowPage, //	页号
                        pageSize: this.mainData.pageSize, //	页大小
                        fcCode: this.mainSearch.query.fcCode || null, //	工厂编号
                        lcCode: this.mainSearch.query.lcCode || null, //	库位编号
                        matCode: this.mainSearch.query.matCode || null, //	物料编号
                        orderCode: this.mainSearch.query.orderCode || null, //	物料描述
                        batchNo: this.mainSearch.query.batchNo || null, //	批次号
                        boxBarcode: this.mainSearch.query.boxBarcode || null, //	箱号
                        wiStatus: sckStatusList || null, //	库存状态
                        beginTime: this.mainSearch.query.beginTime || null,
                        endTime: this.mainSearch.query.endTime || null,
                        whType: this.mainSearch.query.whType || null,
                    },
                })
                .then((res) => {
                    if (res.status == 100) {
                        this.mainData.data = res.data.list || [];
                        this.mainData.total = res.data.total || 0;
                    } else {
                        this.$message.error("错误");
                    }
                });
        },
        //表格导出
        downLoadFile() {
            this.downloadLoading = true;
            let status = "";
            if (this.mainSearch.query.sckStatusList) {
                this.mainSearch.query.sckStatusList = this.mainSearch.query.sckStatusList.join(",");
            }
            var paramsObj = {
                fcCode: this.mainSearch.query.fcCode || null, //	工厂编号
                lcCode: this.mainSearch.query.lcCode || null, //	库位编号
                matCode: this.mainSearch.query.matCode || null, //	物料编号
                orderCode: this.mainSearch.query.orderCode || null, //	订单编号
                batchNo: this.mainSearch.query.batchNo || null, //	批次号
                boxBarcode: this.mainSearch.query.boxBarcode || null, //	箱号
                wiStatus: this.mainSearch.query.sckStatusList || null, //	库存状态
                beginTime: this.mainSearch.query.beginTime || null,
                endTime: this.mainSearch.query.endTime || null,
                whType: this.mainSearch.query.whType || null,
                pageNum: 1,
                pageSize: 999999,
            }

            this.$http.request({
                url: '/api/inventory/getInventoryData',
                method: 'GET',
                params: paramsObj
            }).then((resp) => {
                resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
                    message: '查询失败'
                });
            })
        },
        downLoad(list) {
            import('@/libs/Export2Excel').then(excel => {
                list.forEach(function(c) {
                    if (c.wiStatus == 'NORMAL') {
                        c['wiStatus'] = '正常'
                    } else if (c.wiStatus == 'FREEZE') {
                        c['wiStatus'] = '拣配中'
                        // } else if (c.wiStatus == 'OVERTIME') {
                        //     c['wiStatus'] = '过期'
                        // } else if (c.wiStatus == 'DELETE') {
                        //     c['wiStatus'] = '作废'
                    } else if (c.wiStatus == 'AGFREEZE') {
                        c['wiStatus'] = '冻结'
                    }
                })
                const tHeader = ['通道编号', '物料编号', '物料描述', "订单编号" , '物料数量', '批次号', '库位编号', '箱号', '物料状态', '规值', '入库时间', '创建时间']
                const filterVal = ['whCode', 'matCode', 'matName', 'orderCode','matQuan', 'batchNo', 'lcCode', 'boxBarcode', 'wiStatus', 'matSpecs', 'matCreateTime', 'createTime']
                const data = this.formatJson(filterVal, list)
                excel.export_json_to_excel({
                    header: tHeader,
                    data,
                    filename: '物料状态转换单'
                })
                this.logContent = "导出"
                this.logRemarks = "wh_inventory：导出物料状态转换记录"
                this.systemLog();
                this.downloadLoading = false
            })
        },
        formatJson(filterVal, jsonData) {
            return jsonData.map(v => filterVal.map(j => v[j]))
        },

        /**
         * 操作日志
         */
        systemLog() {
            let objData = {
                logType: "物料状态转换",
                logContent: this.logRemarks || "",
                //logRemarks: this.logRemarks || "",
                logUser: localStorage.getItem("user") || "",
            };
            this.$http
                .request({
                    url: "api/log/insert",
                    method: "POST",
                    showLoading: true,
                    data: objData,
                })
                .then((resp) => {
                    this.logContent = "";
                    this.logRemarks = "";
                    if (resp.status == 100) {}
                })
                .catch((error) => {});
        },
    },
    activated(){
        /* 获取所有的库位 */
        this.getSysLocationAll();
        /* 获取首页的数据 */
        this.getTableData();
    },
}
</script>